import {DataProcessingAgreementModel} from '../../projects/models/data-processing-agreement-model';
import {HttpServiceBase} from '../../../core/services/http-service-base';


export abstract class IDataProcessingAgreementHttpService extends HttpServiceBase {


    public abstract getLatestDataProcessingAgreement(): Promise<DataProcessingAgreementModel>;

    public abstract acceptDataProcessingAgreement(dataProcessingAgreementId): Promise<void>;


}
